import { MenuHeaderProps } from './types';

export const MenuHeader = ({ children }: MenuHeaderProps) => (
  <p className="border-neutral-200 px-2.5 py-1 font-bold leading-6 text-neutral-800 first-of-type:border-none last-of-type:border-t">
    {children}
  </p>
);
